export const GLYPH_SIZE_STORAGE_KEY = 'char-page-glyph-size'
export const DEFAULT_GLYPH_SIZE = 'medium'

export const GLYPH_SIZES = ['small', 'medium', 'large', 'xl', '2xl']

export const GLYPH_SIZE_LABELS = {
  small: 'Small grid size',
  medium: 'Medium grid size',
  large: 'Large grid size',
  xl: 'Extra large grid size',
  '2xl': 'Huge grid size',
}

export const GLYPH_SIZE_TOOLTIP_NAMES = {
  small: 'small',
  medium: 'medium',
  large: 'large',
  xl: 'extra large',
  '2xl': 'huge',
}

export function normalizeGlyphSize(size) {
  return GLYPH_SIZES.includes(size) ? size : DEFAULT_GLYPH_SIZE
}

export function nextGlyphSize(current) {
  const index = GLYPH_SIZES.indexOf(normalizeGlyphSize(current))
  return GLYPH_SIZES[(index + 1) % GLYPH_SIZES.length]
}

/** @param {string} size @param {1 | -1} dir 1 = bigger, -1 = smaller */
export function stepGlyphSize(size, dir) {
  const index = GLYPH_SIZES.indexOf(normalizeGlyphSize(size))
  const nextIndex = Math.max(0, Math.min(GLYPH_SIZES.length - 1, index + dir))
  return GLYPH_SIZES[nextIndex]
}

export function loadGlyphSize() {
  try {
    return normalizeGlyphSize(localStorage.getItem(GLYPH_SIZE_STORAGE_KEY))
  } catch {
    return DEFAULT_GLYPH_SIZE
  }
}

export function saveGlyphSize(size) {
  const normalized = normalizeGlyphSize(size)
  try {
    localStorage.setItem(GLYPH_SIZE_STORAGE_KEY, normalized)
  } catch {
    // Storage may be blocked
  }
  return normalized
}
